import { useMutation } from '@tanstack/react-query';

import { type ParkingGateways } from 'src/features/parkingManagement/api/ParkingGatewayAPIs/useParkingGateways';
import axios from 'src/lib/axios';
import { type MutationConfig } from 'src/lib/react-query';
import { type GeneralSmartParkError } from 'src/types';
import { formatResourcePath } from 'src/utils/regex';

import type { Coordinates } from 'src/features/parkingManagement/types/parking';

const RESOURCE = '/parkings/parking-gateways/:id/';

interface DTO {
    id: string;
    coordinates?: Coordinates;
}

type MutationFnType = typeof mutationFn;
const mutationFn = ({ id, ...data }: DTO): Promise<ParkingGateways> => {
    return axios.patch(formatResourcePath(RESOURCE, { id }), data);
};

interface UseMutationOptions extends MutationConfig<MutationFnType, GeneralSmartParkError> {}
const useMutationHook = (options: UseMutationOptions = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useUpdateParkingGateway };
